




































































































































































































































import Vue from "vue";

// Typescript Files
import * as Api from "@/axios-generated/backoffice/index";

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { required, email } from "@validations";
import useFlowsCreate from "./useFlowsCreate";

export default Vue.extend({
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      required,
      email,
      publicPath: process.env.BASE_URL,
      typeOffersOptions: [
        { value: "select_value", text: "Select Value" },
        {
          value: Api.FlowTypeOffersEnum.Neuf,
          text: Api.FlowTypeOffersEnum.Neuf,
        },
        {
          value: Api.FlowTypeOffersEnum.Ancien,
          text: Api.FlowTypeOffersEnum.Ancien,
        },
      ],
      formatOptions: [
        { value: "select_value", text: "Select Value" },
        {
          value: Api.FlowFormatEnum.PolirisCsv,
          text: Api.FlowFormatEnum.PolirisCsv,
        },
        { value: Api.FlowFormatEnum.ApiXml, text: Api.FlowFormatEnum.ApiXml },
        { value: Api.FlowFormatEnum.ApiJson, text: Api.FlowFormatEnum.ApiJson },
      ],
      statusOptions: [
        { value: "select_value", text: "Select Value" },
        { value: Api.FlowStatusEnum.Created, text: Api.FlowStatusEnum.Created },
        { value: Api.FlowStatusEnum.Enabled, text: Api.FlowStatusEnum.Enabled },
        {
          value: Api.FlowStatusEnum.Suspended,
          text: Api.FlowStatusEnum.Suspended,
        },
        {
          value: Api.FlowStatusEnum.Disabled,
          text: Api.FlowStatusEnum.Disabled,
        },
      ],
    };
  },
  props: {
    newFlow: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { createFlow } = useFlowsCreate();

    const fluxImageOptions = require
      .context("/public/images/flux", true, /^.*\.jpg$/)
      .keys()
      .map((val) => val.replace("./", ""));

    return {
      createFlow,
      fluxImageOptions,
    };
  },
  methods: {
    submitForm(newFlow) {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous confirmer l'opération ?", {
          size: "sm",
          okVariant: "primary",
          okTitle: "Oui",
          cancelTitle: "Non",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.createFlow(newFlow);
          }
        });
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
  },
});
